export const aboutInfo = {
  brand: {
    name: "91影视",
    slogan: "海量高清 · 免费畅享",
    founded: "2018年",
    description: `91影视成立于2018年，是国内领先的在线影视资源平台。自创立以来，我们始终秉持"让每个人都能免费享受高品质影视内容"的初心，致力于为广大用户提供海量、高清、更新及时的影视资源。

经过多年的发展，91影视已积累了超过3万部的影视资源库，涵盖电影、电视剧、动漫、综艺等多个品类。我们的内容团队全天候监控全球热门资源，确保用户能在第一时间观看到最新内容。

91影视坚持免费开放的理念，无需注册、无需会员、无需付费，打开网站即可畅享海量高清内容。我们相信，优质的影视内容应该属于每一个人。`,
    values: [
      {
        title: "免费开放",
        description: "所有资源永久免费，无需注册，无需会员，打开即看",
        icon: "ri-vip-crown-line",
      },
      {
        title: "海量资源",
        description: "超过3万部影视作品，涵盖电影、电视剧、动漫、综艺",
        icon: "ri-database-2-line",
      },
      {
        title: "高清画质",
        description: "主流资源支持1080P，热门资源提供4K超清画质",
        icon: "ri-4k-line",
      },
      {
        title: "更新及时",
        description: "热门资源24小时内同步更新，追剧看片快人一步",
        icon: "ri-flashlight-line",
      },
    ],
  },
  reputation: {
    title: "用户口碑",
    subtitle: "来自真实用户的评价",
    reviews: [
      {
        name: "张先生",
        avatar: "https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-1&orientation=squarish",
        rating: 5,
        content: "用了91影视三年了，资源真的很全。每次有新电影上映，这里很快就能看到高清版。画质清晰、播放流畅，强烈推荐！",
        date: "2026-08-05",
      },
      {
        name: "李女士",
        avatar: "https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-2&orientation=squarish",
        rating: 5,
        content: "追剧党的福音！更新速度真的快，而且不收费不用注册，对比其他平台太良心了。国漫资源特别全，我家孩子很喜欢。",
        date: "2026-08-03",
      },
      {
        name: "王同学",
        avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20student%20portrait%2C%20casual%20style%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-3&orientation=squarish",
        rating: 5,
        content: "作为大学生，免费的影视平台太重要了。91影视资源丰富，分类清晰，手机上看也很方便。已经推荐给全班同学了！",
        date: "2026-08-01",
      },
      {
        name: "赵先生",
        avatar: "https://readdy.ai/api/search-image?query=A%20middle-aged%20Chinese%20male%20portrait%2C%20friendly%20expression%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-4&orientation=squarish",
        rating: 4,
        content: "资源更新速度快，画质也不错。希望后续能增加更多经典老片的资源，有些怀旧电影不太好找。总体很满意！",
        date: "2026-07-28",
      },
      {
        name: "陈女士",
        avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20portrait%2C%20bright%20smile%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-5&orientation=squarish",
        rating: 5,
        content: "综艺更新非常及时，周末在家看《乘风破浪》已经成了固定节目。页面简洁没有广告骚扰，体验一级棒！",
        date: "2026-07-25",
      },
      {
        name: "刘先生",
        avatar: "https://readdy.ai/api/search-image?query=A%20Chinese%20male%20tech%20professional%20portrait%2C%20confident%20look%2C%20simple%20white%20background%2C%20clean%20professional%20headshot&width=100&height=100&seq=avatar-review-6&orientation=squarish",
        rating: 5,
        content: "技术方面做得很到位，多端适配流畅，4K资源加载速度也很快。作为一个开发者，对91影视的技术实力很认可。",
        date: "2026-07-20",
      },
    ],
    stats: {
      totalReviews: "128,500+",
      avgRating: "4.8",
      satisfaction: "98%",
      repeatUsers: "95%",
    },
  },
  contact: {
    title: "联系我们",
    subtitle: "如有任何问题或建议，欢迎随时与我们联系",
    email: "contact@91yingshi.com",
    wechat: "91yingshi_official",
    weibo: "@91影视官方",
    workingHours: "周一至周日 9:00 - 21:00",
    responseTime: "我们会在24小时内回复您的消息",
  },
  faqs: [
    {
      question: "91影视是否需要注册才能观看？",
      answer: "不需要。91影视坚持免费开放的理念，所有影视资源均可在线免费观看，无需注册、无需登录、无需会员。",
    },
    {
      question: "91影视的资源是否正版？",
      answer: "91影视致力于为用户提供合法的影视资源访问渠道。我们严格遵守相关法律法规，所有内容均来自合法授权或公开资源。",
    },
    {
      question: "91影视支持哪些设备观看？",
      answer: "91影视全面支持PC端、平板、手机等多种终端设备。无论您使用Windows、Mac、iOS还是Android系统，都可以流畅访问。",
    },
    {
      question: "为什么有些资源加载比较慢？",
      answer: "资源加载速度受多种因素影响，包括您的网络环境、资源服务器负载等。建议检查网络连接，或尝试切换画质以获得更流畅的播放体验。",
    },
    {
      question: "如何给91影视提建议？",
      answer: "您可以通过本页面的联系表单提交您的建议和反馈，也可以发送邮件至 contact@91yingshi.com。我们珍视每一位用户的意见。",
    },
  ],
};